import React, { Fragment, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteTollLiquidation } from '../../../../actions/route/TollLiquidation';

const TollLiquidationDeleteButton = ({
  tollLiquidationId,
  dispatchDeleteTollLiquidation,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const onClickDelete = () => {
    dispatchDeleteTollLiquidation({ id: tollLiquidationId });
    closeModal();
  };

  return (
    <Fragment>
      <Button color="danger" onClick={openModal}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>

      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
    </Fragment>
  );
};

TollLiquidationDeleteButton.propTypes = {
  tollLiquidationId: PropTypes.string.isRequired,
  dispatchDeleteTollLiquidation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteTollLiquidation: deleteTollLiquidation,
};

export default connect(null, mapDispatchToProps)(TollLiquidationDeleteButton);
